import React, { useRef, useEffect } from 'react';

const api_key = process.env.REACT_APP_GOOGLE_KEY;

function GoogleAutocomplete({ outputFromGoogle }) {
    const autocompleteInputRef = useRef(null);

    useEffect(() => {
        if (!window.google) return;

        const autocomplete = new window.google.maps.places.Autocomplete(autocompleteInputRef.current, {
            types: ['geocode', 'establishment'], // Omezení typů míst (např. adresy)
            componentRestrictions: { country: "cz" }, // Omezení na konkrétní zemi
        });

        autocomplete.addListener("place_changed", () => {
            const selectedPlace = autocomplete.getPlace();

            if (selectedPlace.geometry) {
                const gps = {
                    lat: selectedPlace.geometry.location.lat(),
                    lng: selectedPlace.geometry.location.lng()
                };
                const adres = `${selectedPlace.address_components[1].short_name}, ${selectedPlace.address_components[0].short_name}, ${selectedPlace.address_components[2].short_name}`;

                outputFromGoogle({ gps, adres });
            } else {
                alert("neshoda adresy");
            }
        });
    }, []);

    return (
        <div style={{ position: 'relative', zIndex: 1050, flex: 1 }}>
            <input ref={autocompleteInputRef} type="text" placeholder="Zadejte adresu..." className='InputWithGoogleMapApi' />
        </div>
    );
}

export default GoogleAutocomplete;
